import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSeller } from '../../../context/SellerContext';
import SellerDetailPage from '../SellerDetailPage';

/**
 * Seller Information page — renders SellerDetailPage overview tab as a standalone page.
 */
export default function SellerInfoPage() {
  const navigate = useNavigate();
  const { selectedSeller } = useSeller();

  if (!selectedSeller?.id) {
    navigate('/sellers', { replace: true });
    return null;
  }

  return <SellerDetailPage fixedTab="overview" sellerId={selectedSeller.id} />;
}
